module.exports = __webpack_public_path__ + "img/millfields_rd_b4.97ff104f.jpg";